__turbopack_context__.v({
  "image": "bbdZaa_image",
  "root": "bbdZaa_root" + " " + __turbopack_context__.i(975967)["BentoCardSizeCss"],
  "text": "bbdZaa_text",
});
